import { Outlet } from "react-router-dom";
import Header from '../../components/Header';
import { Theme } from '@radix-ui/themes';


const Layout = () => {
  return (
    <Theme>
      <Header />
      <main>
        <Outlet />
      </main>
    </Theme>
  );
};

export default Layout;
